"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const react_router_redux_1 = require("react-router-redux");
const react_bootstrap_1 = require("react-bootstrap");
const utils_1 = require("../utils");
const AuthenticationActions_1 = require("../authentication/AuthenticationActions");
const constants_1 = require("../constants");
const api_1 = require("../api");
const Loader_1 = require("../shared/Loader");
const Dialog = require("../shared/Dialog/DialogActions");
const { V_LOYAL_REACH } = require('../../../config');
function mapDispatchToProps(dispatch) {
    return {
        register: payload => dispatch(AuthenticationActions_1.register(payload)),
        dispatch
    };
}
class RegisterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.name = "";
        this.email = "";
        this.note = "";
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            state: constants_1.ProgressState.None,
            shouldUpdate: true,
            organization: null,
            hasSubmitted: false,
            isLoading: false
        };
    }
    componentDidMount() {
        document.body.scrollTop = 0;
    }
    handleSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this.isValid()) {
                    return;
                }
                this.setState({
                    isLoading: true
                });
                yield api_1.doPost(api_1.API.v2.ORGANIZATION.REQUESTS.USER.INITIATE(this.props.params.orgRoutePrefix), {
                    userName: this.name,
                    userEmail: this.email,
                    notes: this.note
                });
                Dialog.showAlertDialog({
                    title: "Success",
                    message: "You have submitted your request"
                });
                this.setState({
                    hasSubmitted: true,
                    isLoading: false
                });
            } catch (error) {
                api_1.handleError(error);
            }
        });
    }
    handleKeyPress(target) {
        if (target.charCode !== 13) {
            return;
        }
        switch (target.target.name) {
            case "name":
                $(".panel-body #email").focus();
                break;
            case "email":
                $("#password").focus();
                break;
            case "note":
                this.handleSubmit();
                break;
        }
    }
    scriptsLoaded() {
        api_1.doGet(api_1.API.v2.ORGANIZATION.GET(this.props.params.orgRoutePrefix)).then(response => {
            this.setState({ organization: response.data.response });
        }).catch(error => {
            api_1.handleError(error);
        });
    }
    shouldComponentUpdate() {
        return this.state.shouldUpdate;
    }
    render() {
        return React.createElement("div", null, React.createElement("link", { href: `/css/main.css?V_LOYAL_REACH=${V_LOYAL_REACH}`, rel: "stylesheet" }), React.createElement(Loader_1.default, { libraries: [], onLoad: () => this.scriptsLoaded() }), React.createElement("div", { className: "pl-24 color-blue pt-12" }, React.createElement(react_bootstrap_1.Col, null, this.state.organization && this.state.organization.settings && this.state.organization.settings.logoUrl && React.createElement("img", { width: 100, src: this.state.organization.settings.logoUrl, alt: "organization logo" }), this.state.organization && (!this.state.organization.settings || !this.state.organization.settings.logoUrl) && React.createElement("h2", null, this.state.organization && this.state.organization.name))), React.createElement("div", { className: "flex-center flex-horizontal-center pt-120" }, React.createElement(react_bootstrap_1.Col, { xs: 12, md: 8 }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel organization-auth-panel" }, React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Submit Registration Application"), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "name" }, utils_1.FormUtils.formGroupAttributes(this.state.name)), React.createElement(react_bootstrap_1.FormControl, { "data-cy": "name_signup_cy", placeholder: "Name", type: "text", name: "name", onKeyPress: this.handleKeyPress, disabled: this.state.isLoading, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.name)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ "data-cy": "email_signup_cy", controlId: "email" }, utils_1.FormUtils.formGroupAttributes(this.state.email)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Email", name: "email", type: "email", onKeyPress: this.handleKeyPress, disabled: this.state.isLoading, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.email)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ "data-cy": "note_signup_cy", controlId: "note" }, utils_1.FormUtils.formGroupAttributes(this.state.note)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Note", name: "note", type: "text", onKeyPress: this.handleKeyPress, disabled: this.state.isLoading, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.note)), React.createElement("br", null), React.createElement(react_bootstrap_1.Button, { "data-cy": "submitButton", className: "modal-button organization-login-button", title: "Submit", bsStyle: "primary", disabled: this.state.isLoading, onClick: this.handleSubmit }, "Submit"), React.createElement("br", null), React.createElement("br", null), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { md: 12, className: "text-center" }, React.createElement("a", { href: "javascript:void(0)", onClick: () => this.props.dispatch(react_router_redux_1.push(constants_1.ROUTES.Landing.Login(this.props.params.orgRoutePrefix))) }, "Already have account? Sign in now!"))))))));
    }
    isValid() {
        let valid = true;
        if (validator.isEmpty(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Email is required."
                }
            });
        } else if (!validator.isEmail(this.email)) {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Not valid email format."
                }
            });
        } else {
            this.setState({
                email: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (validator.isEmpty(this.note)) {
            this.setState({
                note: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Note is required."
                }
            });
        } else {
            this.setState({
                note: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        if (validator.isEmpty(this.name)) {
            this.setState({
                name: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Name is required."
                }
            });
        } else {
            this.setState({
                name: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        return valid;
    }
}
const Register = react_redux_1.connect(null, mapDispatchToProps)(RegisterComponent);
exports.default = Register;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/OrganizationUserRegister.tsx
// module id = 1345
// module chunks = 0 1